export default "__VITE_ASSET__BiHUlnra__"